<template>
  <header class="header" :class="{ bgcolor: scrollTop > 200, }">
    <div class="center">
      <div class="left">
        <img src="@/assets/images/logo.png" class="logo">
        DineroAgil
      </div>
      <div class="bar">
        <div
          class="item"
          :class="{ active: ['Home', 'JoinUs'].includes(getActiveName)}"
          @click="jump('/home')"
          @mouseenter="mouseenter('/home')"
          @mouseleave="mouseleave('/home')"
        >
          Inicio
          <transition name="fade">
            <div v-if="showJoinUs" class="hover" @click.stop="jump('/joinUs')" @mouseenter="mouseenter('/home')" @mouseleave="mouseleave('/home')">
              <div class="tab" :class="{ activeTab: 'JoinUs' === getActiveName, }">Únase a nosotros</div>
            </div>
          </transition>
        </div>
        <div class="item" :class="{ active: ['BlogsView', 'BlogDetail'].includes(getActiveName)}" @click="jump('/blogs')">Blog</div>
        <div
          class="item"
          :class="{ active: ['AgreementView', 'SafeView', 'QuestionsView'].includes(getActiveName)}"
          @click="jump('/agreement')"
          @mouseenter="mouseenter('/agreement')"
          @mouseleave="mouseleave('/agreement')"
        >
          Política de Privacidad
          <transition name="fade">
            <div v-if="showHelps" class="hoverAgreement" @mouseenter="mouseenter('/agreement')" @mouseleave="mouseleave('/agreement')">
              <div class="tab" :class="{ activeTab: 'SafeView' === getActiveName, }" @click.stop="jump('/safe')">Seguridad</div>
              <div class="tab" :class="{ activeTab: 'QuestionsView' === getActiveName, }" @click.stop="jump('/questions')">Preguntas frecuentes</div>
            </div>
          </transition>
        </div>
        <!-- <div class="item" :class="{ active: ['AuthorizationView'].includes(getActiveName)}" @click="jump('/authorization')">Autorización</div> -->
      </div>
      <img src="@/assets/images/googleDownload.png" class="right" @click="toDownload">
    </div>
  </header>
</template>

<script>
import debounce from 'lodash.debounce'
export default {
  name: "GlobalHeader",
  data() {
    return {
      hoveringHome: false,
      showJoinUs: false,
      hoveringAgreement: false,
      showHelps: false,
      scrollTop: 0,
    }
  },
  computed: {
    getActiveName() {
      return this.$route.name
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    jump(router) {
      if (router !== this.$route.path) {
        this.$router.push(router)
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    mouseenter(router) {
      switch (router) {
        case '/home':
          this.hoveringHome = true
          this.showJoinUs = true
          break
        case '/agreement':
          this.hoveringAgreement = true
          this.showHelps = true
          break
        default:
          break
      }
    },
    mouseleave(router) {
      switch (router) {
        case '/home':
          this.hoveringHome = false
          this.closeHome('/home')
          break
        case '/agreement':
          this.hoveringAgreement = false
          this.closeAgreement('/agreement')
          break
        default:
          break
      }
    },
    closeHome: debounce(function() {
      if (!this.hoveringHome) {
        this.showJoinUs = false
      }
    }, 300, {
      leading: false,
      trailing: true,
    }),
    closeAgreement: debounce(function() {
      if (!this.hoveringAgreement) {
        this.showHelps = false
      }
    }, 300, {
      leading: false,
      trailing: true,
    }),
    toDownload() {
      this.$store.state.appMarketUrl && window.open(this.$store.state.appMarketUrl)
    },
    handleScroll: debounce(function() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop
    }, 60),
  },
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 124px;
  position: fixed;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  &.bgcolor{
    background-color: #fff;
    border-bottom: 1px solid #6B75F1;
  }
  .center{
    width: 1265px;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .left {
    display: flex;
    align-items: center;
    font-size: 24px;
    font-weight: 600;
    .logo{
      width: 40px;
      height: 40px;
      margin-right: 12px;
    }
  }
  .bar{
    width: 680px;
    height: 68px;
    border-radius: 20px;
    border: 1px solid #6B75F1;
    background-color: #fff;
    box-shadow: 0px 100px 80px 0px rgba(0, 0, 0, 0.02), 0px 64.815px 46.852px 0px rgba(0, 0, 0, 0.02), 0px 38.519px 25.481px 0px rgba(0, 0, 0, 0.01), 0px 20px 13px 0px rgba(0, 0, 0, 0.01), 0px 8.148px 6.519px 0px rgba(0, 0, 0, 0.01), 0px 1.852px 3.148px 0px rgba(0, 0, 0, 0.00);
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #8987A1;
    .item{
      height: 100%;
      flex: 1;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      &.active{
       color: #252432;
       font-weight: 600;
      }
      .hover{
        position: absolute;
        bottom: -90px;
        padding: 24px;
        border-radius: 26px;
        border: 1px solid #6B75F1;
        background-color: #fff;
        box-shadow: 0px 100px 80px 0px rgba(0, 0, 0, 0.02), 0px 64.815px 46.852px 0px rgba(0, 0, 0, 0.02), 0px 38.519px 25.481px 0px rgba(0, 0, 0, 0.01), 0px 20px 13px 0px rgba(0, 0, 0, 0.01), 0px 8.148px 6.519px 0px rgba(0, 0, 0, 0.01), 0px 1.852px 3.148px 0px rgba(0, 0, 0, 0.00);
        .tab{
          color: #8987A1;
          font-size: 16px;
          line-height: 24px;
          min-width: fit-content;
          text-align: center;
          white-space: nowrap;
          margin-bottom: 24px;
          font-weight: 400;
          &:last-child{
            margin-bottom: 0;
          }
          &.activeTab{
            color: #252432;
            font-weight: 600;
          }
        }
      }
      .hoverAgreement{
        @extend .hover;
        bottom: -140px;
      }
      
      .fade-enter-active, .fade-leave-active {
        transition: all 0.3s ease;
      }
      .fade-enter-from, .fade-leave-to {
        opacity: 0;
        transform: translateY(10px);
      }
    }
  }
  .right{
    width: 121px;
    height: 50px;
    border-radius: 25px;
    border: 1px solid #6B75F1;
    cursor: pointer;
  }
}
</style>
